/**
 * Generated bundle index. Do not edit.
 */

export * from './projects';

export {NgxConditionsSelectorFilterComponent as ɵa} from './lib/components/conditions-selector/ngx-conditions-selector-filter/ngx-conditions-selector-filter.component';
export {NgxFiltersParentBase as ɵb} from './lib/ngx-filters-parent-base';
export {RemoveEnterPipe as ɵc} from './lib/pipes/remove-enter.pipe';